import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SiteDto } from '@dto';
import { GenericOldService } from './generic-old.service';

@Injectable({ providedIn: 'root' })
export class SiteService {
  apiUrl: string;

  private readonly siteEmitter = new Subject<SiteDto[]>();

  constructor(private resourceService: GenericOldService<SiteDto>) {
    this.apiUrl = resourceService.apiLocation;
  }

  getAllSites$(): Observable<SiteDto[]> {
    return this.resourceService.getList(`types/site`).pipe(
      tap(sites => {
        this.siteEmitter.next(sites);
      }),
    );
  }

  getSite$(siteId: number | string, includeStores = false, allDers = false): Observable<SiteDto> {
    let params = new HttpParams();
    params = params.set('include_stores', includeStores);
    params = params.set('all_ders', allDers);
    return this.resourceService.getById('sites', siteId, params);
  }

  getSites$(accountId: number | string): Observable<SiteDto[]> {
    return this.resourceService.getList(`accounts/${accountId}/sites`);
  }
}
